import { render, staticRenderFns } from "./appBilibiliPush.vue?vue&type=template&id=29e8a188&scoped=true"
import script from "./appBilibiliPush.vue?vue&type=script&lang=js"
export * from "./appBilibiliPush.vue?vue&type=script&lang=js"
import style0 from "./appBilibiliPush.vue?vue&type=style&index=0&id=29e8a188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e8a188",
  null
  
)

export default component.exports